import {forEach} from "../../../../../wp-includes/js/dist/vendor/wp-polyfill";

const {registerBlockType} = wp.blocks;
const {InspectorControls, useBlockProps} = wp.blockEditor;
const {useState, useEffect} = wp.element;
import classnames from "classnames";
import "../css/blocks.scss";
const {apiFetch} = wp;

const {
    PanelBody,
    SelectControl,
    RangeControl,
    ColorPicker,
    Spinner,
    TextControl,
    TextHighlight,
    TextareaControl,
    SearchControl
} = wp.components;

registerBlockType("sewera/cite", {
    apiVersion: 2,
    title: 'Цитата Sewera',
    category: 'common',
    supports: {},
    icon: "smiley",
    attributes: {
        quantity: {
            type: "number",
            default: 1,
        },
        blockquoteText: {
            type: "string",
            default: "",
        },
    },
    edit: (props)=>{
        const {
            attributes: {quantity, blockquoteText},
            setAttributes,
        } = props;

        const blockProps = useBlockProps({
            className: classnames("components-panel__body is-opened")
        })

        const blockTextarea = useBlockProps({
            className: classnames("block-editor-rich-text__editable", "block-editor-block-list__block", "wp-block", "is-selected", "wp-block-paragraph", "rich-text")
        })

        return (
            <>
                <InspectorControls>
                    <PanelBody>
                        <SelectControl
                            label="Кол-во на страницу"
                            value={quantity}
                            options={[
                                {label: "Светлая", value: 2},
                                {label: "Темная", value: 1},
                            ]}
                            onChange={(val) => setAttributes({quantity: val})}
                        />

                    </PanelBody>

                    <div {...blockProps}>
                        <TextareaControl
                            label="Текст цитаты"
                            help="Введите текст цитаты"
                            value={ blockquoteText }
                            onChange={(val) => setAttributes({blockquoteText: val})}
                        />
                    </div>
                </InspectorControls>

                <div {...blockProps}>
                    <TextareaControl
                        label="Текст цитаты"
                        help="Введите текст цитаты"
                        value={ blockquoteText }
                        onChange={(val) => setAttributes({blockquoteText: val})}
                    />
                </div>

            </>
        )
    },
    save: (props)=>{
        const {
            attributes: {quantity, blockquoteText}
        } = props;

        let eventClassName = 'blockquote-6'

        if(quantity == 1){
            eventClassName = "blockquote-5"
        }

        const citeText = { __html: blockquoteText };

        return <blockquote class={eventClassName} dangerouslySetInnerHTML={citeText}></blockquote>;
    }
})

registerBlockType("sewera/all-sewera", {
    apiVersion: 2,
    title: 'Пост Sewera',
    category: 'common',
    // supports: {},
    // icon: "smiley",
    attributes: {
        post_id: {
            type: "number",
            default: 0,
        },
        posts: {
            type: "Object",
            default: {},
        },
        post_item: {
            type: "Object",
            default: {}
        }
    },
    edit: (props)=>{
        const {
            attributes: {post_id, posts, post_item},
            setAttributes,
        } = props;

        const blockProps = useBlockProps({
            className: classnames("components-panel__body is-opened")
        })

        const [selectOptions,setSelectOptions] = useState([])

        const [events, setEvents] = useState([]);
        useEffect(() => {
          apiFetch({path: "sewera/v1/full_posts"}).then((events) => {
              let options = [{value: '', label: "Выберите пост", disabled: true}]
              events.forEach((elem)=>{
                  if(elem.ID == post_id){
                      setAttributes({post_item: elem})

                      options.push({
                          ID: elem.ID,
                          value: elem.ID,
                          label: elem.post_title,
                          selected: true,
                          guid: elem.guid,
                          image: elem.image,
                          post_date: elem.post_date,
                          post_title: elem.post_title,
                          read_time: elem.read_time,
                          views: elem.views,
                      })
                  }else{
                      options.push({
                          ID: elem.ID,
                          value: elem.ID,
                          label: elem.post_title,
                          guid: elem.guid,
                          image: elem.image,
                          image_alt: elem.image_alt,
                          post_date: elem.post_date,
                          post_title: elem.post_title,
                          read_time: elem.read_time,
                          views: elem.views,
                      })
                  }
              })

            setEvents(options);
            setSelectOptions(options)
          });
        }, [posts]);

        const [searchText,setSearchText] = useState('')

        return (
            <>
                <InspectorControls>
                    <PanelBody>
                        <TextControl
                            label="Поиск по постам"
                            value={searchText}
                            onChange={(val) => {
                                setSearchText(val)

                                if(searchText != '' && searchText.length > 1) {
                                    let newOptions = [{value: '', label: "Выберите пост", disabled: true}]

                                    events.forEach((elem)=>{
                                        if (elem.label.toLowerCase().indexOf(searchText.toLowerCase()) >= 0){
                                            newOptions.push(elem)
                                        }
                                    })

                                    setSelectOptions(newOptions)
                                }else {
                                    setSelectOptions(events)
                                }

                            }}
                        />
                    </PanelBody>

                    <PanelBody>
                        <SelectControl id="post-custom-select"
                                       label="Выберите пост"
                                       value={post_id}
                                       options={selectOptions}
                                       onChange={(val) => {
                                           setAttributes({post_id: val})
                                           events.forEach((elem)=>{

                                               if(elem.value == val){
                                                   setAttributes({post_item: elem})
                                               }
                                           })
                                       }}
                        />

                    </PanelBody>
                </InspectorControls>

                <div class="post__link-page">
                    <div {...blockProps}>{post_item.label ? post_item.label : 'Выберите пост'}</div>
                </div>
            </>
        )
    },
    save: (props)=>{
        const {
            attributes: {post_item},
            setAttributes,
        } = props;

        if(post_item) {
            let views = 0

            if (post_item.views) {
                if (post_item.views < 1000) {
                    views = '';
                } else if (post_item.views > 1000 && post_item.views < 1000000) {
                    views = Math.ceil(post_item.views / 1000) + 'К';
                } else if (post_item.views > 1000000) {
                    views = Math.ceil(post_item.views / 1000000) + 'M';
                }

            }

            return (
                <a target="__blank" href={post_item.guid} className="post__link-page" rel="noopener">
                    { post_item.image && (
                        <div className="post__link-page--image">
                            <img alt={post_item.image_alt} width="64" height="64" src={post_item.image} />
                        </div>
                    )}

                    <div className="post__link-page--title">{post_item.post_title}</div>
                    <ul className="post__link-page--info">
                        <li className="post__link-page--item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M7.99961 4.16156V8.00156L10.5596 9.28156M14.3996 8.00156C14.3996 11.5362 11.5342 14.4016 7.99961 14.4016C4.46499 14.4016 1.59961 11.5362 1.59961 8.00156C1.59961 4.46694 4.46499 1.60156 7.99961 1.60156C11.5342 1.60156 14.3996 4.46694 14.3996 8.00156Z" stroke="#102938" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            <span>{post_item.read_time} мин.</span>
                        </li>

                        { views ? (
                            <li className="post__link-page--item">
                                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 7.0013C1 7.0013 3.66667 1.66797 8.33333 1.66797C13 1.66797 15.6667 7.0013 15.6667 7.0013C15.6667 7.0013 13 12.3346 8.33333 12.3346C3.66667 12.3346 1 7.0013 1 7.0013Z" stroke="#102938" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M8.33333 9.0013C9.4379 9.0013 10.3333 8.10587 10.3333 7.0013C10.3333 5.89673 9.4379 5.0013 8.33333 5.0013C7.22876 5.0013 6.33333 5.89673 6.33333 7.0013C6.33333 8.10587 7.22876 9.0013 8.33333 9.0013Z" stroke="#102938" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                                <span data-post-view-update-id={post_item.ID}>{post_item.views}</span>
                            </li>
                        ) : (
                            <li className="post__link-page--item post__link-page--item-hidden">
                                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 7.0013C1 7.0013 3.66667 1.66797 8.33333 1.66797C13 1.66797 15.6667 7.0013 15.6667 7.0013C15.6667 7.0013 13 12.3346 8.33333 12.3346C3.66667 12.3346 1 7.0013 1 7.0013Z" stroke="#102938" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M8.33333 9.0013C9.4379 9.0013 10.3333 8.10587 10.3333 7.0013C10.3333 5.89673 9.4379 5.0013 8.33333 5.0013C7.22876 5.0013 6.33333 5.89673 6.33333 7.0013C6.33333 8.10587 7.22876 9.0013 8.33333 9.0013Z" stroke="#102938" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                                <span data-post-view-update-id={post_item.ID}>{post_item.views}</span>
                            </li>
                        )}

                        <li className="post__link-page--item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10.5 2.66485V3.99818M10.5 2.66485L5.5 2.66425M10.5 2.66485H12.6667C13.4031 2.66485 14 3.2618 14 3.99818V6.66485M5.5 2.66425L3.33333 2.66485C2.59695 2.66485 2 3.2618 2 3.99818V6.66485M5.5 2.66425V3.99758M2 6.66485V12.6649C2 13.4013 2.59695 13.9982 3.33333 13.9982H12.6667C13.4031 13.9982 14 13.4013 14 12.6649V6.66485M2 6.66485H14" stroke="#102938" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            <span>{post_item.post_date}</span>
                        </li>
                    </ul>
                </a>
            )
        }else{
            return <></>
        }

    }
})

registerBlockType("sewera/cite-author", {
    apiVersion: 2,
    title: 'Цитата c автором Sewera',
    category: 'common',
    supports: {},
    icon: "smiley",
    attributes: {
        author_id: {
            type: "number",
            default: 1,
        },
        author: {
            type: "Object",
            default: 1,
        },
        author_text: {
            type: "string",
            default: "",
        },
        blockquoteHeader: {
            type: "string",
            default: "",
        },
        blockquoteText: {
            type: "string",
            default: "",
        },
    },
    edit: (props)=>{
        const {
            attributes: {author_id, blockquoteText, blockquoteHeader, author, author_text},
            setAttributes,
        } = props;

        const blockProps = useBlockProps({
            className: classnames("components-panel__body is-opened")
        })

        const blockTextarea = useBlockProps({
            className: classnames("block-editor-rich-text__editable", "block-editor-block-list__block", "wp-block", "is-selected", "wp-block-paragraph", "rich-text")
        })

        let authors = {}
        const [events, setEvents] = useState([]);
        useEffect(() => {
            apiFetch({path: "sewera/v1/full_users"}).then((events) => {
                setEvents(events);
            });
        }, [authors]);

        let selectOptions = [{value: '', label: "Выберите автора", disabled: true}]
        events.forEach((elem)=>{

            selectOptions.push({
                value: elem.ID,
                label: elem.name,
                selected: true
            })

        })

        return (
            <>
                <InspectorControls>
                    <PanelBody>
                        <SelectControl
                            label="Выберите автора"
                            value={author_id}
                            options={selectOptions}
                            onChange={(val) => {
                                setAttributes({author_id: val})
                                
                                events.forEach((elem)=> {
                                    if(elem.ID == val) {
                                        setAttributes({author: elem})
                                    }
                                })
                            }}

                        />
                    </PanelBody>

                    <div {...blockProps}>
                        <TextControl
                            label="Подпись автора"
                            value={ author_text }
                            onChange={(val) => setAttributes({author_text: val})}
                        />

                        <TextareaControl
                            label="Введите Заголовок"
                            help="Введите Заголовок"
                            value={ blockquoteText }
                            onChange={(val) => setAttributes({blockquoteHeader: val})}
                        />

                        <TextareaControl
                            label="Введите текст"
                            help="Введите текст"
                            value={ blockquoteText }
                            onChange={(val) => setAttributes({blockquoteText: val})}
                        />
                    </div>
                </InspectorControls>

                <div {...blockProps}>
                    <TextControl
                        label="Подпись автора"
                        value={ author_text }
                        onChange={(val) => setAttributes({author_text: val})}
                    />

                    <SelectControl
                        label="Выберите автора"
                        value={author_id}
                        options={selectOptions}
                        onChange={(val) => {
                            setAttributes({author_id: val})


                            events.forEach((elem)=> {
                                if(elem.ID == val) {
                                    setAttributes({author: elem})
                                }
                            })
                        }}
                    />

                    <TextareaControl
                        label="Введите заголовок"
                        help="Введите заголовок"
                        value={ blockquoteHeader }
                        onChange={(val) => setAttributes({blockquoteHeader: val})}
                    />

                    <TextareaControl
                        label="Введите текст"
                        help="Введите текст"
                        value={ blockquoteText }
                        onChange={(val) => setAttributes({blockquoteText: val})}
                    />
                </div>

            </>
        )
    },
    save: (props)=>{
        const {
            attributes: {author_id, blockquoteText, blockquoteHeader, author, author_text}
        } = props;

        let eventClassName = 'blockquote'

        const citeText = { __html: blockquoteText };
        const citeHeader = { __html: blockquoteHeader };

        return <blockquote class={eventClassName}>
            <div className="blockquote__title" dangerouslySetInnerHTML={citeHeader}></div>

            <div className="blockquote-end">
                { author.avatar && (
                    <img width="49" height="48" src={author.avatar} alt="author" />
                )}
                <div className="blockquote-end__text">
                    { author_text && (
                        <p><strong>{author_text}</strong></p>
                    )}
                    <p>{author.name}</p>
                </div>
            </div>

            <div className="blockquote__text" dangerouslySetInnerHTML={citeText}></div>
        </blockquote>;
    }
})

registerBlockType("sewera/refund", {
    apiVersion: 2,
    title: 'Не терятся Sewera',
    category: 'common',
    supports: {},
    icon: "smiley",
    attributes: {
        img_html: {
            type: "string",
            default: '',
        },
        href: {
            type: "string",
            default: 'https://t.me/+nwq8zLg6Y9tmM2My',
        },
        text_html: {
            type: "string",
            default: '',
        },
    },
    edit: (props)=>{
        const {
            attributes: {href, img_html, text_html},
            setAttributes,
        } = props;

        const blockProps = useBlockProps({
            className: classnames("components-panel__body is-opened")
        })

        return (
            <>
                <InspectorControls>
                    <div {...blockProps}>
                        <TextControl
                            label="Ссылка"
                            value={ href }
                            onChange={(val) => setAttributes({href: val})}
                        />

                        <TextControl
                            label="Текст (Если не заполнено выводится по дефолту)"
                            value={ text_html }
                            onChange={(val) => setAttributes({text_html: val})}
                        />

                        <TextareaControl
                            label="Ссылка на изображение (Если не указана будет выводится дефолтное)"
                            value={ img_html }
                            onChange={(val) => setAttributes({img_html: val})}
                        />
                    </div>
                </InspectorControls>

                <div {...blockProps}>
                    <TextControl
                        label="Ссылка"
                        value={ href }
                        onChange={(val) => setAttributes({href: val})}
                    />

                    <TextControl
                        label="Текст (Если не заполнено выводится по дефолту)"
                        value={ text_html }
                        onChange={(val) => setAttributes({text_html: val})}
                    />

                    <TextareaControl
                        label="HTML иконки (Если не заполнено выводится по дефолту)"
                        value={ img_html }
                        onChange={(val) => setAttributes({img_html: val})}
                    />
                </div>

            </>
        )
    },
    save: (props)=>{
        const {
            attributes: {href, img_html, text_html},
            setAttributes,
        } = props;

        const textHtml = text_html ? `<span>${text_html}</span>` : '<span>Мы в Телеграм</span>'

        let imgHtml = {}
        if(img_html){
            imgHtml = { __html: img_html + textHtml };
        }else{
            imgHtml = { __html: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.23687 9.88815C7.06875 7.62995 10.2909 6.14155 11.903 5.42224C16.5061 3.36884 17.4625 3.01185 18.0857 3.00012C18.2229 2.99763 18.5292 3.0339 18.7281 3.2067C18.8959 3.35248 18.9419 3.54982 18.9641 3.68814C18.9864 3.82645 19.0139 4.14184 18.992 4.38789C18.7427 7.199 17.6634 14.0209 17.1141 17.1694C16.8817 18.5018 16.4242 18.9483 15.9813 18.9921C15.0187 19.087 14.2881 18.3097 13.3556 17.6544C11.8967 16.6286 11.0726 15.9904 9.65674 14.9895C8.02015 13.8328 9.08126 13.1971 10.0138 12.1581C10.2577 11.8861 14.4989 7.74871 14.5808 7.37323C14.5911 7.3263 14.6007 7.15136 14.5035 7.05891C14.4064 6.96646 14.2635 6.99811 14.1604 7.02335C14.0143 7.05891 11.6838 8.71123 7.1692 11.98C6.50786 12.4671 5.90852 12.7046 5.37183 12.6922C4.78011 12.6783 3.64175 12.3334 2.79544 12.0383C1.75753 11.6763 0.932437 11.485 1.00437 10.8702C1.04183 10.5502 1.45289 10.2227 2.23754 9.88815H2.23687Z" fill="#102938"/>
                                </svg>
                                ${textHtml}` };
        }

        // const templateUrl = settings_theme.templateUrl;
        const templateUrl = '/journal/wp-content/themes/sewera';
        const image = `${templateUrl}/assets/images/card-return.svg`

        return (
            <div className="post__return">
                <img width="60" height="61" src={image} alt="post-return" />
                    <p className="post__return--text">Давайте-ка не теряться</p>

                    <a target="__blank" rel="noopener" className="btn btn-primary" href={ href } dangerouslySetInnerHTML={ imgHtml } />
            </div>
        )
    }
})

registerBlockType("sewera/br", {
    apiVersion: 2,
    title: 'Пустой отступ Sewera',
    category: 'common',
    supports: {},
    icon: "smiley",
    attributes: {
    },
    edit: (props)=>{
        const blockProps = useBlockProps({
            className: classnames("components-panel__body is-opened")
        })

        return (
            <>
                <InspectorControls>
                    <div {...blockProps}>
                        Отступ
                    </div>
                </InspectorControls>

                <div {...blockProps}>
                    Отступ
                </div>

            </>
        )
    },
    save: (props)=>{
        return (
            <br/>
        )
    }
})
